import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { resolveFunnelUrlByMonetizationTest } from '@/helpers';
import { landingAiImageCombinerConfig } from '@/data/landingConfig/landingAiImageCombinerConfig';
import { MONETIZATION_TEST } from '@/constants';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiImageCombiner } from './schemaObject';

interface Props {}
const AiImageCombiner: React.FC<Props> = () => {
	const funnelUrl = resolveFunnelUrlByMonetizationTest(
		{
			[MONETIZATION_TEST.NON_TIER_1]:
				GenerateLandingLinkService.funnelAiImageCombinerV2,
		},
		GenerateLandingLinkService.funnelAiImageCombiner,
	);
	return (
		<>
			<AggregateSchema schema={schemaObject_AiImageCombiner} />
			<LandingTemplate
				data={landingAiImageCombinerConfig}
				funnelLinkService={funnelUrl}
			/>
		</>
	);
};

export default AiImageCombiner;
